export default function SuppliedVector() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
			<path
				stroke="#6e7591"
				d="M12.7 14v-1.3A2.7 2.7 0 0 0 10 10H6a2.7 2.7 0 0 0-2.7 2.7V14M8 7.3A2.7 2.7 0 1 0 8 2a2.7 2.7 0 0 0 0 5.3Z"
			/>
		</svg>
	);
}
